module.exports = __webpack_public_path__ + "img/top_icon1.8df2abb2.png";